/**
 * 收货地址 / 个人中心 / 卡券 / 提现
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/address',
    name: 'address',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/address/index.vue'
      ),
    meta: {
      title: '我的收货地址',
      isCommon: true
    }
  },
  {
    path: '/userCenter',
    name: 'userCenter',
    redirect: '/userCenter/cards',
    // 个人中心默认重定向到卡券
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/userCenter/index.vue'
      ),
    meta: {
      title: '个人中心',
      isCommon: true
    },
    children: [
      {
        path: '/userCenter/cards',
        name: 'cards',
        component: resolve => require(['@/views/cards/list'], resolve),
        meta: {
          title: '我的福利',
          isCommon: true
        }
      },
      {
        path: '/userCenter/order',
        name: 'order',
        component: resolve => require(['@/views/order/order_list'], resolve),
        meta: {
          title: '我的订单',
          keepAlive: true,
          isCommon: true
        }
      },
      {
        path: '/userCenter/address',
        // 原来与 /address 同名 address（按 name 跳转会命中前一条）
        name: 'userAddress',
        component: resolve => require(['@/views/address'], resolve),
        meta: {
          title: '收货地址',
          isCommon: true
        }
      },
      {
        // 售后服务：与卡券/订单/地址同级（都在用户中心里渲染）。
        // 原来挂在 /after_sales/list（独立一级页面），从左侧菜单点进来会跳出用户中心
        path: '/userCenter/afterSales',
        name: 'userCenterAfterSales',
        component: resolve => require(['@/views/afterSales/list'], resolve),
        meta: {
          title: '售后服务',
          keepAlive: true,
          isCommon: true
        }
      },
      {
        path: '/userCenter/changePassword',
        name: 'changePassword',
        component: resolve =>
          require(['@/views/userCenter/changePwd'], resolve),
        meta: {
          title: '修改密码',
          isCommon: true
        }
      },
      {
        path: '/userCenter/addChildren',
        name: 'addChildren',
        component: resolve =>
          require(['@/views/userCenter/addChildren'], resolve),
        meta: {
          title: '子女信息',
          isCommon: true
        }
      }
    ]
  },
  {
    path: '/card_list',
    name: 'cardList',
    component: () =>
      import(
        /* webpackChunkName: "card" */
        '@/views/cards/list.vue'
      ),
    meta: {
      title: '我的熊猫卡',
      isCommon: true
    }
  },
  {
    path: '/bind_card',
    name: 'bindCard',
    component: () =>
      import(
        /* webpackChunkName: "card" */
        '@/views/cards/bind.vue'
      ),
    meta: {
      title: '绑定新卡券',
      isCommon: true
    }
  },
  {
    path: '/bindCard',
    // 原来与 /bind_card 同名 bindCard（两条路由指向同一个页面）
    name: 'bindCardAlias',
    component: () =>
      import(
        /* webpackChunkName: "card" */
        '@/views/cards/bind.vue'
      ),
    meta: {
      title: '绑定新卡券',
      isCommon: true
    }
  },
  {
    path: '/card_detail',
    name: 'cardDetail',
    component: () =>
      import(
        /* webpackChunkName: "card" */
        '@/views/cards/detail.vue'
      ),
    meta: {
      // 与 h5 /center/cardDeatails 的标题保持一致
      title: '福利详情',
      isCommon: true
    }
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    component: () =>
      import(
        /* webpackChunkName: "card" */
        '@/views/withdraw/index.vue'
      ),
    meta: {
      title: '申请提现',
      isCommon: true
    }
  },
  {
    path: '/withdraw/records',
    name: 'withdrawRecords',
    component: () =>
      import(
        /* webpackChunkName: "card" */
        '@/views/withdraw/records.vue'
      ),
    meta: {
      title: '提现记录',
      isCommon: true
    }
  }
];
